type RunningThread = {
  getState(): { isRunning: boolean };
  subscribe(callback: () => void): () => void;
};

/** Abort the transport without the UI runtime's delayed history rollback. */
export function cancelBeforeSend(thread: RunningThread, cancelResume: () => void): Promise<void> {
  return new Promise((resolve, reject) => {
    let unsubscribe = () => {};
    let finished = false;
    const finish = (error?: unknown) => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      unsubscribe();
      if (error) reject(error);
      else resolve();
    };
    const check = () => {
      if (!thread.getState().isRunning) finish();
    };
    const timeout = setTimeout(() => finish(new Error('Previous voice turn did not stop')), 5000);
    try {
      unsubscribe = thread.subscribe(check);
      if (finished) return unsubscribe();
      cancelResume();
      check();
    } catch (error) {
      finish(error);
    }
  });
}
